import { create } from "zustand";
import { SurveysImages } from "@/types/surveys";
import firstImgActive from "@/assets/images/surveys/1_active.png";
import secondImgActive from "@/assets/images/surveys/2_active.png";
import thirdImgActive from "@/assets/images/surveys/3_active.png";
import fourthImgActive from "@/assets/images/surveys/4_active.png";
import firstImgNotActive from "@/assets/images/surveys/1_not_active.png";
import secondImgNotActive from "@/assets/images/surveys/2_not_active.png";
import thirdImgNotActive from "@/assets/images/surveys/3_not_active.png";
import fourthImgNotActive from "@/assets/images/surveys/4_not_active.png";

const surveysImagesData: SurveysImages[] = [
  {
    id: 1,
    imgNotActive: firstImgNotActive,
    imgActive: firstImgActive,
  },
  {
    id: 2,
    imgNotActive: secondImgNotActive,
    imgActive: secondImgActive,
  },
  {
    id: 3,
    imgNotActive: thirdImgNotActive,
    imgActive: thirdImgActive,
  },
  {
    id: 4,
    imgNotActive: fourthImgNotActive,
    imgActive: fourthImgActive,
  },
];

interface SurveysImagesStore {
  surveysImages: SurveysImages[];
}

export const useSurveysImagesStore = create<SurveysImagesStore>(() => ({
  surveysImages: surveysImagesData,
}));
